(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ContactManagerImportController', [
            'MW.ContactManager.CsvSelector',
            'MW.ContactManager.AutoDownloader',
            'MW.ContactManager.ContactManagerNavigationService',
            'MW.Framework.InfluencerContactService',
            'MW.ContactManager.ContactManagerFlashService',
            'MW.CoreStream.ContactManagerTagService',
            'MW.CoreStream.ContactTagsList',
            'MW.Influencers.AnalyticsService',
            'MW.Framework.CoreUserService',
            'MW.Framework.CoreCompanyService',
            'Configuration',
            'ngMaterial'
        ])
        .controller('ContactManagerImportController', [
            '$scope',
            '$translate',
            '$mdDialog',
            'breadcrumbs',
            'ContactManagerNavigationService',
            'InfluencerContactService',
            'CONTACT_MANAGER_TEMPLATE_URL',
            'ContactManagerFlashService',
            'companyId',
            'ContactManagerTagService',
            'AnalyticsService',
            'CoreUserService',
            'CoreCompanyService',
            '$q',
            ContactManagerImportController
        ]);

    function ContactManagerImportController(
        $scope,
        $translate,
        $mdDialog,
        breadcrumbs,
        ContactManagerNavigationService,
        InfluencerContactService,
        CONTACT_MANAGER_TEMPLATE_URL,
        ContactManagerFlashService,
        companyId,
        ContactManagerTagService,
        AnalyticsService,
        CoreUserService,
        CoreCompanyService,
        $q
    ) {
        this.$scope = $scope;
        this.$q = $q;
        this.$translate = $translate;
        this.$mdDialog = $mdDialog;
        this.breadcrumbs = breadcrumbs;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.InfluencerContactService = InfluencerContactService;
        this.ContactManagerFlashService = ContactManagerFlashService;
        this.fileContents = '';
        this.templateUrl = CONTACT_MANAGER_TEMPLATE_URL + '/contact/csv/comma';
        this.failedCsv = '';
        this.selectedMediaLists = [];
        this.companyId = companyId;
        this.enableImportButton = false;
        this.ContactManagerTagService = ContactManagerTagService;
        this.AnalyticsService = AnalyticsService;
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;

        this.setDescription(CONTACT_MANAGER_TEMPLATE_URL);
    }

    ContactManagerImportController.prototype.setDescription = function setDescription(templateRoot) {
        this.templateUrl1 = templateRoot + '/contact/csv/comma';
        this.templateUrl2 = templateRoot + '/contact/csv/semicolon';
        this.exampleUrl1 = 'https://en.wikipedia.org/wiki/Decimal_mark#Countries_using_Arabic_numerals_with_decimal_point';
        this.exampleUrl2 = 'https://en.wikipedia.org/wiki/Decimal_mark#Countries_using_Arabic_numerals_with_decimal_comma';
    };

    ContactManagerImportController.prototype.fileSelected = function fileSelected(fileContents) {
        this.fileContents = fileContents;
        this.$scope.$apply(); //re render this.fileContents to DOM
    };

    ContactManagerImportController.prototype.cancelImport = function cancelImport() {
        this.ContactManagerNavigationService.goToContactAddLanding();
    };

    ContactManagerImportController.prototype.confirmImport = function confirmImport(ev) {
        var confirmMessage = this.$translate.instant('icm-web__data-controller--import-contacts-msg'),
        okButton = this.$translate.instant('Ok'),
        cancelButton = this.$translate.instant('Cancel');

        this.$mdDialog.show(
            this.$mdDialog.mwConfirm()
                .textContent(confirmMessage)
                .ok(okButton)
                .cancel(cancelButton)
                .targetEvent(ev)
        ).then(
            () => {
                this.importCsv();
            },
            () => {}
        );
    };

    ContactManagerImportController.prototype.importCsv = function importCsv() {
        var self = this;
        this.enableImportButton = true;

        this.InfluencerContactService.importCsv(this.fileContents, this.selectedMediaLists).then(function(response) {
            self.ContactManagerFlashService.flashSuccess(response.message);
            self.ContactManagerNavigationService.goToList();
            self.trackEvent(response.payload);
        }).catch(function (response) {
            var error = response.error;
            // handle various error cases
            switch(error.reason) {
                case 'FAILED_CREATE':
                    self.ContactManagerFlashService.flashWarning('One or more contacts failed to import.');
                    // on a partial import we need to return a csv to the user
                    self.failedCsv = error.data;
                    self.ContactManagerNavigationService.goToList();
                    break;
                case 'INVALID_TEMPLATE':
                    var errorMessage = 'The CSV file does not appear to be valid. Please check that you are using our standard [[templateLink]].',
                        messageParams = {
                            templateLink: '<a class="flashErrorLink" target="_self" href="' + self.templateUrl + '">template</a>'
                        };

                    self.enableImportButton = false;
                    self.ContactManagerFlashService.flashError(null, errorMessage, messageParams);
                    break;
                default:
                    self.enableImportButton = false;
                    self.ContactManagerFlashService.flashError(null, 'Oops. Something went wrong. Please try importing your contacts again later.');
                    break;
            }
        });
    };

    ContactManagerImportController.prototype.trackEvent = function trackEvent(payload) {
        var promises = [],
            currentUser,
            currentCompany,
            trackingData;

        promises.push(this.CoreUserService.getCurrent(true));
        promises.push(this.CoreCompanyService.getCurrent(true));

        this.$q.all(promises).then(function(responses) {
            currentUser = responses[0];
            currentCompany = responses[1];
            trackingData = {
                source: 'webapp',
                label: 'import_contact',
                mediaListId: 'All Contacts',
                contactCount: payload.length,
                parentType: 'ICM_import_contacts',
                userId: currentUser.email + ' (' + currentUser._id + ') ' + currentCompany.name
            };
            if (this.selectedMediaLists.length === 0) {
                this.AnalyticsService.trackMediaListOperation('import_contact', trackingData);
            }
            else {
                this.selectedMediaLists.forEach(function(list) {
                    trackingData.mediaListId = list;
                    this.AnalyticsService.trackMediaListOperation('import_contact', trackingData);
                }.bind(this));
            }

        }.bind(this));
    };
}());
